import { Button } from '@mantine/core';
import { IconFileTypeDocx } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface CenterReportButtonProps {
  researchCenterId: Id;
}

const onDownload = (researchCenterId: Id) => {
  window.open(`/api/research-centers/report/${researchCenterId}/latest/docx`);
};

export function CenterReportButton({ researchCenterId }: CenterReportButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeDocx size="24px" />}
      onClick={() => onDownload(researchCenterId)}
    >
      Descarcă raport pe centru de cercetare
    </Button>
  );
}
